import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { Button } from "@/shared/components/Button";

export interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ message, onRetry, className }: ErrorStateProps) {
  const t = useTranslations();

  return (
    <div
      role="alert"
      className={`rounded-xl border border-[color:var(--error-200)] bg-[color:var(--error-50)] px-4 py-4 ${className ?? ""}`}
    >
      <p className="text-sm text-[color:var(--error-500)]">
        {message ?? t(keys.errors.generic)}
      </p>
      {onRetry ? (
        <div className="mt-3">
          <Button
            type="button"
            onClick={onRetry}
            variant="outline"
            size="sm"
          >
            {t(keys.common.retry)}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
